import React, { useState, useEffect, useRef } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Link, useNavigate } from "react-router-dom";
import './index.css'
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from 'chart.js';
import api from '../../../Services/api';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import MonthlyData from '../Vendor/monthlydata';
import ReportTable from '../Vendor/reporttable';


ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);




const DoughnutChart = ({ accepted, rejected, underReview }) => {
  // Prepare the data for the doughnut chart
  const total = accepted + rejected + underReview;
  const notUploaded = Math.max(0, 100 - total);
  const data = {
    labels: ['Accepted', 'Rejected', 'Under Review', 'Not Uploaded'],// The label and remaining portion
    datasets: [
      {

        data: [accepted, rejected, underReview, notUploaded], // Data for each status
        backgroundColor: [
          '#50c878',  // Accepted (green)
          '#B22222',  // Rejected (red)
          '#EFCC00',  // Under Review (gray)
          'lightgray'
        ],
        borderWidth: 0,
        borderColor: '#eeee'
      }
    ],
  };

  // Set the options for the doughnut chart (e.g., cutout, rotation)
  const options = {
    cutout: '40%',


    responsive: true,
    plugins: {
      legend: { display: true, position: 'top' },
      tooltip: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem) {
            // Get the percentage value from the tooltipItem
            const percentageValue = tooltipItem.raw;

            // Add the percentage symbol to the tooltip value
            return `${percentageValue}%`;
          }
        } // Disable tooltip if not needed
      },
      datalabels: {
        display: false
      }

    },
  };

  return (

    <div style={{ height: '333px', width: '236px' }}>
      <h1
        style={{
          fontSize: '18px',
          color: '#1C1C1C',
          position: 'relative',
          top: '165px',
          left:
            accepted >= 100
              ? '100px'
              : accepted >= 10
                ? '106px'
                : '112px'
        }}
      >
        {accepted}%
      </h1>

      <Doughnut data={data} options={options} />

    </div>


  );
};



const Index = () => {
  let data = sessionStorage.getItem('user');
  let vendorData = JSON.parse(data);
  let vendorId = vendorData.id;

  const [vendorChartData, setVendorChartData] = useState({});

  const marqueeRef = useRef(null);
  const navigate = useNavigate();
  const [vendorsData, setVendorsData] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [showAlert, setShowAlert] = useState(false)
  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [rejectedPercentage, setRejectedPercentage] = useState(0);
  const [underReview, setUnderReview] = useState(0);

  const handlePercentagesChange = (rejected, underreview) => {
    setRejectedPercentage(rejected);
    setUnderReview(underreview);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      vendorDetails();
      masterData(vendorId);
    }, 600)
    return () => clearTimeout(timer);
  }, [vendorId]);



  useEffect(() => {
    if (rejectedPercentage != null && rejectedPercentage > 0) {
      setShowAlert(true);
    }
  }, [rejectedPercentage]);

  const handleUploadingClick = () => {
    navigate('/masterdata')
  }
  const handleMouseOver = () => {
    if (marqueeRef.current) {
      marqueeRef.current.stop();
    }
  };

  const handleMouseOut = () => {
    if (marqueeRef.current) {
      marqueeRef.current.start();
    }
  };

  const vendorDetails = async () => {
    const response = await api.vendor.findvendor();
    const temp = response.data.filtterData;
    setVendorsData(temp);
    console.log(temp, "vendorDetails");
  };
  const handleClick = ({ status, month, year }) => {
    console.log(status, "month");
    navigate('/monthlydata', {
      state: {
        filter: status.charAt(0).toLowerCase() + status.slice(1),
        month: month < 10 ? `0${month}` : `${month}`,
        year: year,
      },
    });
  };

  const masterData = async (vendorId) => {
    try {
      const response = await api.masterData.getVendorMasterData(vendorId);
      if (response.status === 200) {
        const chartData = response.data;
        setVendorChartData((prevData) => ({
          ...prevData,
          [vendorId]: chartData,
        }));
      

        setLoading(false)
      }
      else if (response.status === 404) {
        setSnackbarOpen(true);
        setSnackbarErrorMessage("MasterData not found for this vendor");
        setLoading(false)
      }
      else if (response.status === 500) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setLoading(false)
      }
      else if (response.status === 400) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setLoading(false)

      } else {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage("Error fetching master data.");
        setLoading(false)
      }
    } catch (error) {
      console.error("Error fetching vendor details:", error);
    }
  };
 






useEffect(() => {
  const chart = vendorChartData?.[vendorId];
  if (!chart) return;

  const accepted = chart.acceptPercentage || 0;
  const rejected = chart.rejectPercentage || 0;
  const underReview = chart.URpercent || 0;
  const total = accepted + rejected + underReview;

  if (total <= 0) {
    setErrorSnackbarOpen(true);
    setSnackbarErrorMessage("Start Uploading MasterData");
  }
}, [vendorChartData, vendorId]);

const getChartData = (vendorId) => {
  if (!vendorChartData[vendorId]) return {};
  const chart = vendorChartData[vendorId];

  const accepted = chart.acceptPercentage || 0;
  const rejected = chart.rejectPercentage || 0;
  const underReview = chart.URpercent || 0;
  const total = accepted + rejected + underReview;

  return { accepted, rejected, underReview, total };
};

  return (
    <>
      {loading ? (
        <div className="d-flex flex-row align-items-center justify-content-center" style={{ marginTop: '80px' }}>
          <h3>Loading</h3>
          <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem', marginLeft: '10px' }} role="status"></div>
          <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem', marginLeft: '10px' }} role="status"></div>
          <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem', marginLeft: '10px' }} role="status"></div>
        </div>
      ) : (

        <div style={{ overflow: 'hidden' }}>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            severity="success"
            open={snackbarOpen}
            autoHideDuration={4000}
            onClose={() => setSnackbarOpen(false)}
            sx={{ marginTop: '2.9%', marginRight: '7%' }}
          >
            <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
          </Snackbar>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            severity="error"
            open={errorSnackbarOpen}
            autoHideDuration={5000}
            sx={{ marginTop: '2.9%', marginRight: '7%' }}
            onClose={() => setErrorSnackbarOpen(false)}
          >
            <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
          </Snackbar>
          {showAlert && (
            <div>
              <marquee ref={marqueeRef} className="pt-2" behavior="scroll" direction="left" scrollamount="5"

              >
                <span
                  className="text-color"
                  style={{ cursor: 'pointer', fontSize: "15px" }}
                  onMouseOver={handleMouseOver}
                  onMouseOut={handleMouseOut}
                  onClick={() => {
                    const currentDate = new Date();

                    const prevMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1);
                    handleClick({
                      status: 'rejected',
                      month: prevMonthDate.getMonth() + 1,
                      year: prevMonthDate.getFullYear(),
                    })
                  }
                  }
                >
                  <i className="text-light p-1 bg-danger" style={{ borderRadius: '50px', fontSize: '11px' }}><span className='blink'>Alert</span></i> The compliance percentage for the current month is <span style={{ color: 'red' }}>{rejectedPercentage}%</span>. Kindly upload the missing documents
                </span>
              </marquee>
            </div>

          )}

          <div className='mx-4 mt-2' style={{ display: 'grid', gridTemplateColumns: '0.5fr 1fr 0.5fr', gridTemplateRows: '1fr 0fr 0fr', gap: '5px' }}>

            {/* First Row */}
            <div style={{ backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: '100%' }}>
              {Object.keys(vendorChartData).map((vendorId) => {
                const { Compliant, accepted, rejected, underReview, notUploaded, total } = getChartData(vendorId);
                return (
                  <div key={vendorId} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: '100%', border: '1px solid lightgray' }}>

                    {/* Ensure that h6 takes up full width */}
                    <h6 className="text-center  text-light p-2 mb-2" style={{ backgroundColor: 'rgba(0,0,0,0.85)', width: '100%', textAlign: 'center', marginTop: '0px' }}>
                      Master Data
                    </h6>

                    {total > 0 ? (
                      <DoughnutChart
                        accepted={accepted}
                        rejected={rejected}
                        underReview={underReview}
                        notUploaded={notUploaded}
                      />
                    ) : (
                      <p style={{ padding: '40px', color: 'gray', fontStyle: 'italic' }}>
                        <button  onClick={handleUploadingClick}>Start Uploading </button>
                      </p>
                    )}

                  </div>
                );
              })}
            </div>
            <MonthlyData />

            <ReportTable
              rejected={rejectedPercentage}
              underReview={underReview}

              onPercentagesChange={handlePercentagesChange}
            />

          </div>


          <div className="mx-5 d-flex flex-wrap justify-content-center align-items-center">

            <div className="mx-2 p-2" style={{ minWidth: '150px', maxWidth: 'auto', height: '60px', backgroundColor: 'rgba(0,0,0,0.85)' }}>
              <h6 className="text-center text-light fw-bold">{vendorsData.vendorCompanyName}</h6>
              <h6 className='text-center text-secondary' style={{ fontSize: '11px' }}>Vendor/Company Name</h6>
            </div>

            <div className="mx-2 p-2" style={{ minWidth: '150px', maxWidth: 'auto', height: '60px', backgroundColor: 'rgba(0,0,0,0.2)' }}>
              <h6 className="text-center text-dark fw-bold">{vendorsData.natureOfWork}</h6>
              <h6 className='text-center text-secondary' style={{ fontSize: '11px' }}>Nature Of Work</h6>
            </div>

            <div className="mx-2 p-2" style={{ minWidth: '150px', maxWidth: 'auto', height: '60px', backgroundColor: 'rgba(0,0,0,0.85)' }}>
              <h6 className="text-center text-light fw-bold">{vendorsData.vendorContractStartDate?.slice(0, 10).split('-').reverse().join('-')}</h6>
              <h6 className='text-center text-secondary' style={{ fontSize: '11px' }}>Contract-Start Date</h6>
            </div>

            <div className="mx-2 p-2" style={{ minWidth: '150px', maxWidth: 'auto', height: '60px', backgroundColor: 'rgba(0,0,0,0.2)' }}>
              <h6 className="text-center text-dark fw-bold">{vendorsData.vendorContractEndDate?.slice(0, 10).split('-').reverse().join('-')}</h6>
              <h6 className='text-center text-secondary' style={{ fontSize: '11px' }}>Contract-End Date</h6>
            </div>


            {/* <div className="mx-2 p-2" style={{ minWidth: '150px',maxWidth:'auto',height:'60px',backgroundColor: 'rgba(0,0,0,0.85)' }}>
    <h6 className='text-center text-light fw-bold'>{rejectedPercentage}%</h6>
    <h6 className='text-center text-secondary' style={{fontSize:'11px'}}>Open Risks</h6>
    </div> */}

            {/* <div className="mx-2 p-2" style={{ minWidth: '150px',maxWidth:'auto', backgroundColor: 'rgba(0,0,0,0.85)' }}>
    <h6 className='text-center text-light fw-bold'>{underReview}%</h6>
    <h6 className='text-center text-secondary' style={{fontSize:'11px'}}>Under Review</h6>
   
    </div> */}
          </div>


        </div>
      )}
    </>
  );
};

export default Index;
